import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const body = document.body;
  const alertsBar = document.querySelector('.alerts-bar__inner');
  const closeButton = document.querySelector('.alerts-bar__close-button');
  const alertsBarWrapper = document.getElementById('alerts-bar');

  let lastScrollTop = 0;
  let scrollDirection = 'up';

  const updateAlertVisibilityAndHeight = () => {
    if (!alertsBarWrapper) return;

    if (scrollDirection === 'down') {
      alertsBarWrapper.style.setProperty('--AlertHeight', '0px');
      document.documentElement.style.setProperty('--AlertHeight', '0px');
      alertsBarWrapper.style.visibility = 'hidden';
    } else {
      const height = alertsBarWrapper.offsetHeight + 'px';
      alertsBarWrapper.style.setProperty('--AlertHeight', height);
      document.documentElement.style.setProperty('--AlertHeight', height);
      alertsBarWrapper.style.visibility = 'visible';
    }
  };

  const closeAlertBar = () => {
    const swiperContainer = document.querySelector('.alerts-bar-swiper');
    if (swiperContainer) swiperContainer.remove();
    body.classList.remove('alerts-bar-active');
  };

  if (alertsBar) {
    body.classList.add('alerts-bar-active');
    new Swiper(alertsBar, {
      slidesPerView: 1,
      pagination: {
        el: '.alert-controls',
        clickable: true,
      },
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', closeAlertBar);
  }

  const handleScroll = () => {
    const currentScroll = window.scrollY;

    if (currentScroll > lastScrollTop) {
      scrollDirection = 'down';
    } else if (currentScroll < lastScrollTop) {
      scrollDirection = 'up';
    }

    updateAlertVisibilityAndHeight();

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  };

  window.addEventListener('scroll', () => {
    setTimeout(handleScroll, 50);
  });

  window.addEventListener('resize', updateAlertVisibilityAndHeight);

  const observer = new MutationObserver(() => {
    updateAlertVisibilityAndHeight();
  });

  observer.observe(body, {
    attributes: true,
    attributeFilter: ['class'],
  });

  updateAlertVisibilityAndHeight();
});
